import { logWrapper } from '../utils';

export default {
  roleModel: [
    'runtimeConstant',
    'featureModel',
    function (runtimeConstant, Feature) {
      function Role(data) {
        this.id = data ? data.Id : 0;
        this.name = data ? data.Name : '';
        this.description = data ? data.Description : '';
        this.RolesFeatures = data ? data.RolesFeatures : [];
        if (data && data.RolesFeatures) {
          this.RolesFeaturesList = data.RolesFeatures.map(
            (f) => new Feature(f.Feature, false)
          );
        }

        this.selected = false;
      }

      function title() {
        return this.name;
      }

      function details() {
        return this.description ? this.description : '';
      }

      function tags() {
        return this.RolesFeaturesList.map((feature) => feature.name);
      }

      function anyFeatureSelected() {
        return this.allFeatures.some((e) => e.selected === true);
      }

      function isValid() {
        return this.name && this.anyFeatureSelected();
      }

      function toggleAll(value) {
        if (arguments.length > 0) {
          this.allFeatures.forEach((d) => (d.selected = value));
        } else {
          if (this.allFeatures === undefined || this.allFeatures === null)
            return false;
          return this.allFeatures.every((d) => d.selected === true);
        }
      }

      function run() {
        try {
          Role.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            anyFeatureSelected: logWrapper(
              anyFeatureSelected,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            toggleAll: logWrapper(
              toggleAll,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Role;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
